import * as React from "react";

import "./design.css";
import { useNavigate } from "react-router-dom";
import { Winning } from "../Model/Auction";
import Toolbar from "./toolbar"
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Typography } from "@mui/material";
import {encodeId, decodeId} from "../../hash";

function MyLots() {
  const [dataWinnging, setGetWinning] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [total, setTotal] = React.useState(0);

  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    getWinning(value)
  };

  
  const getWinning = (value) => {
    setLoading(true);
    try {
      async function WinningLot() {
        const results = await Winning(value);
        // console.log(results.data)
if(results.success === false){
  setLoading(false);
  setGetWinning([]);
  setTotal(0);
}else{
  setLoading(false);
  setGetWinning(results.data);


  const totalPages = Math.ceil(results.pagination.total / 10);
  
  setTotal(totalPages);
}
       
      }
      WinningLot().catch((error) => {
        setLoading(false);
      });
    } catch (error) {}
  };

  React.useEffect(() => {
    getWinning();
  }, []);


  const gotoSinglePage = (slug,title,auction_id,lotNumber) => {


    const cleanTitle = title === null
    ? "untitle"
    : title.replace(/[^a-zA-Z0-9-_]/g, "");
    window.location.href  = `/auctions/${slug.replace(/ /g, '-')}/${cleanTitle}/${encodeId(auction_id)}/${lotNumber}`;


  }


  return (

    <React.Fragment>
    <CssBaseline />
    <Container maxWidth="xl" style={{  marginTop: 50,}}>

   
          <Toolbar title={"My Lots"} />

    <Box
      style={{
        marginTop: 40,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(400px, 100%), 1fr))",
        gap: 3,
      }}
    >
     
      {dataWinnging.length ?
      dataWinnging.map((val, index) => {
        return (
          <div class="winning-lots-container" key={index} onClick={(e) => gotoSinglePage(val.auction_name,val.title, val.auction_id, val.lot_number)} style={{cursor: 'pointer'}}>
              <div style={{ paddingBottom: 15,}}>
              <p style={{fontSize: 18}}>{val.auction_name}</p>
              </div>

            <div class="lot-card">
              <div
                alt={index}
                style={{
                  backgroundImage: `url(${
                    val.img_url === null
                      ? "https://placehold.co/360x370?text=NO%20IMAGE%20AVAILABLE"
                      : val.img_url
                  })`,
                  backgroundColor: "#ffffff",
                  width: "100%",
                  height: 200,
                  display: "inline-block",
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
              {/* <img src={val.img_url} alt={index} /> */}
              <div class="lot-details">
              
              <p class="artist">Lot: {val.lot_number}</p>
                <h3>{val.title}</h3>
                <p class="artist">Artist: {val.artist}</p>
                  <p class="price">Total Amount w/ Buyer’s Premium :  ₱ {val.hammer_price === null ? 0:val.hammer_price.toLocaleString() }</p>
                {/* <p class="status won">Status: Won ✅</p> */}
              </div>
            </div>
          </div>
        );
      }):  <div style={{margin: 'auto',position: 'absolute'}}>
        <Typography style={{textAlign: 'center'}}>No records found</Typography>
        </div>}
    </Box>

    <div style={{marginTop: 50, marginBottom: 50}}>
<div style={{margin: 'auto',textAlign: 'center'}}>


    <Stack spacing={2} style={{margin: 'auto'}}>
{/* <Typography>Page: {page}</Typography> */}
      <Pagination  style={{margin: 'auto'}} count={total} variant="outlined" shape="rounded"   page={page} onChange={handleChange}/>
    </Stack>
    </div>
    </div>
    </Container>
  </React.Fragment>
  );
}

export default MyLots;
